export default defineAppConfig({
  ui: {
    primary: 'indigo',
    gray: 'neutral',
    notifications: {
      position: 'top-0 bottom-auto'
    },
    variables: {
      header: {
        height: '3rem'
      }
    },
    // Use heroicons for component defaults so Carbon is not required at runtime
    icons: {
      loading: 'i-heroicons-arrow-path',
      refresh: 'i-heroicons-arrow-path',
      'pie-chart': 'i-heroicons-chart-pie'
    },
    // Button radius: rounded-lg (8px) — design system / industry standard
    button: {
      slots: {
        base: [
          'rounded-lg font-medium inline-flex items-center disabled:cursor-not-allowed aria-disabled:cursor-not-allowed disabled:opacity-75 aria-disabled:opacity-75',
          'transition-colors'
        ]
      }
    }
  }
})
